import { AxiosRequestConfig } from 'axios';

import { apiClient } from '@/lib/api/client';
import { ApiSuccessResponse } from '@/lib/api/types';

import {
  Chat,
  ChatUnreadResposne,
  CreateChatBody,
  Message,
  SendMessagePayload,
} from '../types';

/**
 * Send a message to the store of a product.
 */
export const createChat = async (
  data: CreateChatBody,
  options?: AxiosRequestConfig,
) => {
  return apiClient<ApiSuccessResponse>(
    {
      method: 'POST',
      url: '/chats',
      data,
    },
    options,
  );
};

export const getUserChats = (options?: AxiosRequestConfig) => {
  return apiClient<Chat[]>(
    {
      method: 'GET',
      url: `/chats`,
    },
    options,
  );
};

export const getChatMessages = (
  chatId: string,
  options?: AxiosRequestConfig,
) => {
  return apiClient<Message[]>(
    {
      method: 'GET',
      url: `/chats/${chatId}/messages`,
    },
    options,
  );
};

export const getUnreadChats = (options?: AxiosRequestConfig) => {
  return apiClient<ChatUnreadResposne[]>(
    {
      method: 'GET',
      url: `/chats/unread`,
    },
    options,
  );
};

export const sendMessage = (
  { body, chatId }: SendMessagePayload,
  options?: AxiosRequestConfig,
) => {
  return apiClient<Message>(
    {
      method: 'POST',
      url: `/chats/${chatId}/messages`,
      data: { body },
    },
    options,
  );
};
